import './FoodItem.css';

export default function SubOption({
  subOption,
  addonId,
  optionId,
  selected,
  onChange,
  optionQuantity
}) {
  const handleRadioChange = () => {
      if (selected) {
        onChange(addonId, optionId, subOption, optionQuantity,false)
      } else {
        onChange(addonId, optionId, subOption, optionQuantity,true)
      }
  };

  return (
    <label className='suboption'>
      <input
        // type='radio' // or "checkbox", depending on your config
        type='checkbox'
        checked={selected}
        onChange={handleRadioChange}
        className='me-2 fake-radio'
      />
      {/* {subOption.subOptionName}  ${subOption.price} */}
      {subOption.subOptionName}
      {selected && optionQuantity > 0 && <span> (x{optionQuantity}) </span>}
      {/* <span>${subOption.price}</span> */}
       {selected ? <span>
        £{(optionQuantity > 0 ? subOption.price * optionQuantity : subOption.price).toFixed(2)}
      </span> : <span>£{subOption.price}</span>}
    </label>
  );
}
